<template>

    <div :class="[name, 'filter-items', 'open']">
    <!-- {open: open} -->

    <div v-if="label" class="filter-label"> {{ label }} </div>

    <template v-for="f in filters">

        <filter-checkbox
            v-if="f.type == 'checkbox'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :selected="selected[f.name]"
            :open="focus == f.name"
            :disabled="disabled.includes(f.name)"
        />

        <filter-single
            v-if="f.type == 'single'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :selected="selected[f.name]"
            :open="focus == f.name"
            :disabled="disabled.includes(f.name)"
        />

        <filter-multi
            v-else-if="f.type == 'multi'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :open="focus == f.name"
            :disabled="disabled.includes(f.name)"
        />

        <filter-minmax
            v-else-if="f.type == 'minmax'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :selected="selected[f.name]"
            :open="focus == f.name"
            :manual=false
            :disabled="disabled.includes(f.name)"
        />

        <filter-minmax
            v-else-if="f.type == 'minmax-manual'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :selected="selected[f.name]"
            :open="focus == f.name"
            :manual=true
            :disabled="disabled.includes(f.name)"
        />

        <filter-fromto
            v-else-if="f.type == 'fromto'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :selected="selected[f.name]"
            :disabled="disabled.includes(f.name)"
        />

        <filter-building
            v-if="f.type == 'building'"
            :key="f.name"
            :name="f.name"
            :defaultLabel="f.label"
            :options="f.options"
            :selected="selected[f.name]"
            :open="focus == f.name"
            :disabled="disabled.includes(f.name)"
        />

    </template>

    <div v-if="role != 'verified' && name=='filter-bar-more'" class="filter-menu">

        <div class="filter-label">
        </div>

        <div class="flex-grow-1 position-relative alert alert-primary">
            <p v-if="role == 'unverified'" class="text-center mb-0">
               <a :href="verifyLink">Verfiy your account</a> to use the full set of filters.
            </p>
            <p v-else class="text-center mb-0">
               <a href="/signup" @click.prevent="$emit('signup')">Sign up</a> to use the full set of filters.
            </p>
        </div>
    </div>


    </div>

</template>


<script>

/* global appData */

import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

// import FilterDialog from '@/mls-filter/components/filters/FilterDialog.vue';
import FilterSingle from '@/mls-filter/components/filters/FilterSingle.vue';
import FilterCheckbox from '@/mls-filter/components/filters/FilterCheckbox.vue';
import FilterMulti from '@/mls-filter/components/filters/FilterMulti.vue';
import FilterMinMax from '@/mls-filter/components/filters/FilterMinMax.vue';
import FilterFromTo from '@/mls-filter/components/filters/FilterFromTo.vue';
import FilterBuilding from '@/mls-filter/components/filters/FilterBuilding.vue';

export default {

    props: {
        filters: Array,
        label: String,
        name: String,
        // verifyLink: String,
        // open: { type: Boolean, default: true }
    },

    computed: {
        ...mapState([
            'selected',
            'sorting',
            'focus',
            'disabled',
            'role',
        ]),
        verifyLink() {
            return appData.externals.verifyLink;
        },
    },

    methods: {
        // getVerifyLink() {
        //     return appData.externals.verifyLink;
        // }

    },

    components: {
        // 'filter-dialog': FilterDialog,
        'filter-single': FilterSingle,
        'filter-checkbox': FilterCheckbox,
        'filter-multi': FilterMulti,
        'filter-minmax': FilterMinMax,
        'filter-fromto': FilterFromTo,
        'filter-building': FilterBuilding,
    },
};

</script>


<style lang="scss">
</style>
